import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "qualification-requirement-section"
}
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-[640px]" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "flex items-center gap-2 text-base font-bold text-[#163D45]" }, [
    /*#__PURE__*/_createTextVNode(" Qualificação exigida "),
    /*#__PURE__*/_createElementVNode("span", { class: "rounded-full bg-primary5 px-2 py-0.5 text-xs font-bold text-primary40" }, " Novo ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-600" }, " Quais selos e documentos (aprovados no Drive do Médico) o médico precisa ter para ser alocado nesta escala, e o que fazer se não tiver. ")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "rounded-lg border border-gray-300 bg-gray-100 px-3 py-2 text-sm",
  "data-testid": "qualification-unavailable"
}
const _hoisted_5 = {
  key: 0,
  class: "rounded-lg border border-alert bg-orange-50 px-3 py-2 text-sm",
  "data-testid": "qualification-notice"
}
const _hoisted_6 = {
  key: 1,
  class: "rounded-lg border border-sucess bg-green-50 px-3 py-2 text-sm",
  "data-testid": "qualification-copied-notice"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, [
  /*#__PURE__*/_createTextVNode(" Marque o que o médico precisa ter. Itens marcados são exigidos "),
  /*#__PURE__*/_createElementVNode("strong", null, "juntos"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_8 = { class: "flex min-w-0 flex-1 flex-col gap-1" }
const _hoisted_9 = { class: "pl-8 text-xs text-gray-500" }
const _hoisted_10 = { class: "flex min-w-0 flex-1 flex-col gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "pl-8 text-xs text-gray-500" }, "Certificados ATLS, ACLS e PALS", -1)
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col gap-2 pl-8"
}
const _hoisted_13 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold text-gray-600" }, "Exigir", -1)
const _hoisted_15 = { class: "flex flex-wrap gap-4" }
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-negative",
  "data-testid": "qualification-shortcut-life-support-error"
}
const _hoisted_17 = { class: "qr-card opacity-60" }
const _hoisted_18 = { class: "flex min-w-0 flex-1 flex-col gap-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "pl-8 text-xs text-gray-500" }, "RQE na especialidade", -1)
const _hoisted_20 = { class: "flex flex-col gap-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-bold text-[#163D45]" }, "Outros documentos exigidos", -1)
const _hoisted_22 = ["data-testid"]
const _hoisted_23 = { class: "flex-1 text-sm font-semibold" }
const _hoisted_24 = { class: "max-w-[360px]" }
const _hoisted_25 = {
  class: "flex flex-wrap items-center justify-between gap-2 rounded-lg bg-[#F0F0F4] px-3 py-2 text-sm",
  "data-testid": "qualification-advanced-banner"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("strong", null, "Modo avançado.", -1)
const _hoisted_27 = ["disabled", "title"]

import { computed, ref, watch } from 'vue'
import { mdiClose, mdiPlus } from '@mdi/js'

import Checkbox from '@/components/designSystem/Checkbox/index.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import SegmentedControl from '@/components/designSystem/SegmentedControl/SegmentedControl.vue'
import type { SegmentedOption } from '@/components/designSystem/SegmentedControl/SegmentedControl.vue'
import { useErrorToast } from '@/composables/useErrorToast'
import {
  CATALOG_LOAD_ERROR,
  useProfessionalDocumentCatalogStore
} from '@/pinia-store/useProfessionalDocumentCatalogStore'
import { ProfessionalSealKey } from '@/types/professional-documents.types'
import { QualificationOnFail } from '@/types/qualification-eligibility.types'
import type { QualificationRuleGroup } from '@/types/qualification-policy.types'

import CopyRequirementsModal from './CopyRequirementsModal.vue'
import OnFailSelector from './OnFailSelector.vue'
import PolicyBuilder from './PolicyBuilder.vue'
import PolicySummary from './PolicySummary.vue'
import {
  LIFE_SUPPORT_KEYS,
  clonePolicy,
  emptyShortcuts,
  isPolicyEmpty,
  policyToShortcuts,
  shortcutErrors,
  shortcutsToPolicy,
  validatePolicy
} from './policyModel'
import type { LifeSupportMode, RequirementShortcuts } from './policyModel'

type CheckboxEvent = { isChecked: boolean; value: string | null }


export default /*#__PURE__*/_defineComponent({
  __name: 'QualificationRequirementSection',
  props: {
    modelValue: {},
    notice: { default: null }
  },
  emits: ["update:modelValue", "validityChange", "copiedFrom"],
  setup(__props: any, { emit }) {

const props = __props;




const catalog = useProfessionalDocumentCatalogStore()
const { notifyError } = useErrorToast()
// Sem catálogo os nomes caem na chave e o autocomplete fica vazio; a falha vira toast. O 404 da
// flag desligada não lança: a store marca `isUnavailable` e a seção mostra o aviso.
catalog.ensureLoaded().catch((error) => notifyError(error, CATALOG_LOAD_ERROR))

const LIFE_SUPPORT_MODES: SegmentedOption[] = [
  { value: 'ANY', label: 'Pelo menos um' },
  { value: 'ALL', label: 'Todos' }
]

const mode = ref<'shortcuts' | 'advanced'>('shortcuts')
const shortcuts = ref<RequirementShortcuts>(emptyShortcuts())
const advanced = ref<QualificationRuleGroup>(clonePolicy(props.modelValue))
const copyOpen = ref(false)
const copied = ref(false)

/** Política que os atalhos não expressam abre direto no modo avançado (Review Focus 2). */
function load(next: QualificationRuleGroup) {
  const asShortcuts = policyToShortcuts(next)
  mode.value = asShortcuts ? 'shortcuts' : 'advanced'
  shortcuts.value = asShortcuts ?? emptyShortcuts()
  advanced.value = clonePolicy(next)
}
load(props.modelValue)

const policy = computed<QualificationRuleGroup>(() =>
  mode.value === 'shortcuts' ? shortcutsToPolicy(shortcuts.value) : advanced.value
)
const lifeSupportError = computed(
  () => mode.value === 'shortcuts' && shortcutErrors(shortcuts.value).length > 0
)
// Nos atalhos também vale o limite de largura do backend (muitos documentos avulsos na raiz).
const errors = computed(() =>
  mode.value === 'shortcuts'
    ? [...shortcutErrors(shortcuts.value), ...validatePolicy(policy.value)]
    : validatePolicy(advanced.value)
)
const canGoBack = computed(() => policyToShortcuts(advanced.value) !== null)

const minimumDocsDescription = computed(
  () =>
    catalog.seals.find((seal) => seal.key === ProfessionalSealKey.MINIMUM_DOCS)?.description ||
    'Identidade, CRM, Diploma e certidões Concluídos + CRM Ativo na base'
)
const availableDocuments = computed(() =>
  catalog.types
    .filter((type) => !shortcuts.value.extraDocuments.some((doc) => doc.key === type.key))
    .map((type) => ({ title: type.name, value: type.key }))
)

/** Só emite o que mudou de fato (evita laço com o `watch` do `modelValue`). */
let lastEmitted = JSON.stringify(props.modelValue)
watch(
  policy,
  (next) => {
    const serialized = JSON.stringify(next)
    if (serialized === lastEmitted) return
    lastEmitted = serialized
    emit('update:modelValue', clonePolicy(next))
  },
  { deep: true }
)
watch(
  () => props.modelValue,
  (next) => {
    const serialized = JSON.stringify(next)
    if (serialized === lastEmitted) return
    lastEmitted = serialized
    load(next)
  },
  { deep: true }
)
watch(
  () => errors.value.length === 0,
  (valid) => emit('validityChange', valid),
  { immediate: true }
)

const onMinimumDocs = (event: CheckboxEvent) => (shortcuts.value.minimumDocs = event.isChecked)
const onLifeSupport = (event: CheckboxEvent) => (shortcuts.value.lifeSupport = event.isChecked)
// O SegmentedControl só oferece as opções de `LIFE_SUPPORT_MODES`.
const onLifeSupportMode = (value: string) =>
  (shortcuts.value.lifeSupportMode = value as LifeSupportMode)

/** Mantém a ordem ATLS, ACLS, PALS (o vai-e-volta com a árvore fica estável). */
function onLifeSupportKey({ isChecked, value }: CheckboxEvent) {
  if (!value) return
  const selected = shortcuts.value.lifeSupportKeys
  const next = isChecked ? [...selected, value] : selected.filter((item) => item !== value)
  shortcuts.value.lifeSupportKeys = LIFE_SUPPORT_KEYS.filter((item) => next.includes(item))
}

function addExtraDocument(key: string | null) {
  if (!key) return
  shortcuts.value.extraDocuments.push({ key, onFail: QualificationOnFail.BLOCK })
}

function goAdvanced() {
  advanced.value = shortcutsToPolicy(shortcuts.value)
  mode.value = 'advanced'
}

function backToShortcuts() {
  const asShortcuts = policyToShortcuts(advanced.value)
  if (!asShortcuts) return
  shortcuts.value = asShortcuts
  mode.value = 'shortcuts'
}

function onCopy(
  rules: QualificationRuleGroup,
  sourcePolicyId: number,
  sourceCompanyId: number | null
) {
  load(rules)
  copied.value = true
  copyOpen.value = false
  emit('copiedFrom', sourcePolicyId, sourceCompanyId)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_unref(catalog).isUnavailable)
        ? (_openBlock(), _createBlock(OutlineButton, {
            key: 0,
            text: "Copiar requisitos de outra escala",
            height: "40px",
            width: "auto",
            class: "px-4",
            "data-testid": "qualification-copy-open",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (copyOpen.value = true))
          }))
        : _createCommentVNode("", true)
    ]),
    (_unref(catalog).isUnavailable)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " A qualificação exigida ainda não foi liberada neste ambiente. "))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.notice)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.notice), 1))
            : _createCommentVNode("", true),
          (copied.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Requisitos copiados de outra escala. A partir de agora esta escala tem uma cópia própria. "))
            : _createCommentVNode("", true),
          (mode.value === 'shortcuts')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_7,
                _createElementVNode("div", {
                  class: _normalizeClass(["qr-card", { 'qr-card--on': shortcuts.value.minimumDocs }])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(Checkbox, {
                      "field-id": "qualification-shortcut-minimum-docs",
                      label: "Documentação Mínima",
                      checked: shortcuts.value.minimumDocs,
                      "data-testid": "qualification-shortcut-minimum-docs",
                      "onUpdate:checked": onMinimumDocs
                    }, null, 8, ["checked"]),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(minimumDocsDescription.value), 1)
                  ]),
                  (shortcuts.value.minimumDocs)
                    ? (_openBlock(), _createBlock(OnFailSelector, {
                        key: 0,
                        modelValue: shortcuts.value.minimumDocsOnFail,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shortcuts.value.minimumDocsOnFail) = $event)),
                        "test-id": "qualification-shortcut-minimum-docs-on-fail"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["qr-card", { 'qr-card--on': shortcuts.value.lifeSupport, 'qr-card--error': lifeSupportError.value }])
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(Checkbox, {
                      "field-id": "qualification-shortcut-life-support",
                      label: "Suporte a Vida",
                      checked: shortcuts.value.lifeSupport,
                      "data-testid": "qualification-shortcut-life-support",
                      "onUpdate:checked": onLifeSupport
                    }, null, 8, ["checked"]),
                    _hoisted_11,
                    (shortcuts.value.lifeSupport)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createVNode(SegmentedControl, {
                              "model-value": shortcuts.value.lifeSupportMode,
                              options: LIFE_SUPPORT_MODES,
                              ariaLabel: "Como combinar os certificados",
                              size: "sm",
                              "test-id": "qualification-shortcut-life-support-mode",
                              "onUpdate:modelValue": onLifeSupportMode
                            }, null, 8, ["model-value"])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LIFE_SUPPORT_KEYS), (key) => {
                              return (_openBlock(), _createBlock(Checkbox, {
                                key: key,
                                "field-id": `qualification-shortcut-life-support-${key}`,
                                label: _unref(catalog).typeName(key),
                                value: key,
                                checked: shortcuts.value.lifeSupportKeys.includes(key),
                                "data-testid": `qualification-shortcut-life-support-${key}`,
                                "onUpdate:checked": onLifeSupportKey
                              }, null, 8, ["field-id", "label", "value", "checked", "data-testid"]))
                            }), 128))
                          ]),
                          (lifeSupportError.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Escolha ao menos um certificado (ATLS, ACLS ou PALS) ou desmarque Suporte a Vida. "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (shortcuts.value.lifeSupport)
                    ? (_openBlock(), _createBlock(OnFailSelector, {
                        key: 0,
                        modelValue: shortcuts.value.lifeSupportOnFail,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shortcuts.value.lifeSupportOnFail) = $event)),
                        "test-id": "qualification-shortcut-life-support-on-fail"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(Checkbox, {
                      "field-id": "qualification-shortcut-specialist",
                      label: "Especialista",
                      checked: false,
                      disabled: "",
                      "data-testid": "qualification-shortcut-specialist"
                    }),
                    _hoisted_19
                  ]),
                  _createVNode(LabelBadge, {
                    label: "Em breve",
                    color: "gray",
                    size: "small",
                    icon: null
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shortcuts.value.extraDocuments, (doc, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: doc.key,
                      class: "qr-card qr-card--on",
                      "data-testid": `qualification-extra-${doc.key}`
                    }, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(catalog).typeName(doc.key)), 1),
                      _createVNode(OnFailSelector, {
                        modelValue: doc.onFail,
                        "onUpdate:modelValue": ($event: any) => ((doc.onFail) = $event),
                        "test-id": `qualification-extra-${doc.key}-on-fail`
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "test-id"]),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        variant: "text",
                        size: "small",
                        density: "compact",
                        "aria-label": `Remover ${_unref(catalog).typeName(doc.key)}`,
                        "data-testid": `qualification-extra-${doc.key}-remove`,
                        onClick: ($event: any) => (shortcuts.value.extraDocuments.splice(index, 1))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: _unref(mdiClose),
                            size: "20"
                          }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["aria-label", "data-testid", "onClick"])
                    ], 8, _hoisted_22))
                  }), 128)),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_v_autocomplete, {
                      "model-value": null,
                      items: availableDocuments.value,
                      label: "Adicionar documento do catálogo",
                      variant: "outlined",
                      density: "compact",
                      color: "primary20",
                      "hide-details": "",
                      "prepend-inner-icon": _unref(mdiPlus),
                      "no-data-text": "Nenhum tipo disponível",
                      "data-testid": "qualification-extra-add",
                      "onUpdate:modelValue": addExtraDocument
                    }, null, 8, ["items", "prepend-inner-icon"])
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "self-start text-sm font-semibold text-primary30 hover:underline",
                  "data-testid": "qualification-go-advanced",
                  onClick: goAdvanced
                }, " Modo avançado — combinar critérios com E/OU ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", null, [
                    _hoisted_26,
                    (!canGoBack.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" Esta política usa combinações (grupos E/OU) que os atalhos não mostram. ")
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-sm font-semibold text-primary30 hover:underline disabled:cursor-not-allowed disabled:text-gray-400 disabled:no-underline",
                    disabled: !canGoBack.value,
                    title: canGoBack.value ? '' : 'Remova os subgrupos para voltar aos atalhos',
                    "data-testid": "qualification-back-to-shortcuts",
                    onClick: backToShortcuts
                  }, " Voltar aos atalhos ", 8, _hoisted_27)
                ]),
                _createVNode(PolicyBuilder, {
                  modelValue: advanced.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((advanced).value = $event))
                }, null, 8, ["modelValue"])
              ], 64)),
          _createVNode(PolicySummary, {
            policy: policy.value,
            errors: errors.value
          }, null, 8, ["policy", "errors"])
        ], 64)),
    _createVNode(CopyRequirementsModal, {
      "modal-active": copyOpen.value,
      "has-current-requirements": !_unref(isPolicyEmpty)(policy.value),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (copyOpen.value = false)),
      onCopy: onCopy
    }, null, 8, ["modal-active", "has-current-requirements"])
  ]))
}
}

})